import { ProgressBar as Bs5ProgressBar } from 'react-bootstrap5';

export default Bs5ProgressBar;
